var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"PartsLoading"},[_c('div',{staticClass:"PartsLoading-wrapper"},[_c('div',{staticClass:"PartsLoading-circle"}),_c('p',{staticClass:"PartsLoading-text"},[_vm._v(_vm._s(_vm.label))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }